import AnalyticsService from '@root/core/src/services/analytics-service';
import AttributionQueryParamService from '@root/attribution/src/services/attribution-query-param-service';
import { useEffect } from '@root/vendor/react';

export let hasRegistered = false;

export function resetRegistration() {
  hasRegistered = false;
}

export default function useRegisterAgentAttribution() {
  useEffect(() => {
    if (hasRegistered) { return; }

    const attribution = AttributionQueryParamService.read();
    const agentId = attribution?.agent_id;
    const agencyId = attribution?.agency_id;

    if (agentId || agencyId) {
      hasRegistered = true;
      AnalyticsService.register({
        agent_id: agentId || null,
        agency_id: agencyId || null,
      });
    }
  }, []);
}
